
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import defensiveCopy from "@/util/defensive-copy";
import { RuleGroup } from "@/types/conditions";
import ConditionPreviewRule from "@/components/Reusable/CustomInputs/ConditionInput/ConditionPreviewRule.vue";
import Icon from "@/components/UI/Icon.vue";

@Component({
  components: { ConditionPreviewRule, Icon }
})
export default class ConditionsPreview extends Vue {
  @Prop()
  value!: RuleGroup[] | undefined;

  edit(value: unknown) {
    this.$emit("input", defensiveCopy(value));
  }
}
